import React from "react";
import { useCurrency } from "../../context/CurrencyContext";

const CurrencyDisplay = ({
  amountUSD,
  currency: overrideCurrency,
  compact = false,
  showOriginal = false,
  className = "",
}) => {
  const {
    currency: currentCurrency,
    convertPrice,
    formatPrice,
    getAllPrices,
  } = useCurrency();

  if (!amountUSD && amountUSD !== 0) {
    return <span className={className}>-</span>;
  }

  const targetCurrency = overrideCurrency || currentCurrency;
  const convertedAmount = convertPrice(amountUSD);
  const formattedPrice = formatPrice(convertedAmount, targetCurrency);

  if (compact) {
    return (
      <span className={`currency-display compact ${className}`}>
        {formattedPrice}
      </span>
    );
  }

  if (showOriginal) {
    const allPrices = getAllPrices(amountUSD);
    const formattedAll = {
      usd: formatPrice(allPrices.usd, "USD"),
      sll: formatPrice(allPrices.sll, "SLL"),
      myr: formatPrice(allPrices.myr, "MYR"),
    };
    return (
      <span className={`currency-display with-all ${className}`}>
        <span className="primary-price">{formattedAll.sll}</span>
        <span className="all-currencies">
          <span className="currency-sep">•</span>
          <span className="currency-item">{formattedAll.usd}</span>
          <span className="currency-sep">•</span>
          <span className="currency-item">{formattedAll.myr}</span>
        </span>
      </span>
    );
  }

  return (
    <span className={`currency-display ${className}`}>{formattedPrice}</span>
  );
};

export default CurrencyDisplay;
